import React, {Component} from 'react';
import {Menu} from 'semantic-ui-react';
import {NavLink, Route, Redirect, Switch} from 'react-router-dom';

import Page from '../layout/Page';
import AllCustomersTable from './AllCustomersTable';
import NewCustomerForm from './NewCustomerForm';

class IndexScreen extends Component {
  state = {};

  render() {
    return (
      <Page.Basic
        title="Customer Listing"
        secondary={
          <Menu secondary pointing>
            <Menu.Item as={NavLink} to="/manage/customers" exact>
              All Customers
            </Menu.Item>
            <Menu.Item as={NavLink} to="/manage/customers/new">
              Add New Customer
            </Menu.Item>
          </Menu>
        }
      >
        <Switch>
          <Route exact path="/manage/customers" component={AllCustomersTable} />
          <Route path="/manage/customers/new" component={NewCustomerForm} />
          <Redirect to="/manage/customers" />
        </Switch>
      </Page.Basic>
    );
  }
}

export default IndexScreen;
